import React, { useEffect, useState } from 'react';
import { ModernStatWidget } from '../../Components/DashboardCard';
import axiosInstance from '../../../../../Services/axiosCommon';

const Equipments = () => {
  const [data, setData] = useState([]);

  async function getData() {
    try {
      const res = await axiosInstance.get(`/new-dashboard/vehicles-and-equipments`);
      setData(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const EquipmentIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Equipment"
      value={data?.equipments || 0}
      icon={EquipmentIcon}
      bgColor="bg-purple-500/10"
      iconColor="text-purple-600"
    />
  );
};

export default Equipments;